<template>
  <b-modal class="modal-lg" :id="deleteItemModal.id" :title="deleteItemModal.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="resetModal">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light">{{ t(deleteItemModal.title, deleteItemModal.title) }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="row modal-body-log">
        <div v-if="deleteItemModal.itemId" class="col-lg-12 py-2"><span> {{t(deleteItemModal.question, deleteItemModal.question)}} </span> </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ close }">
      <button type="button" class="btn btn-secondary" @click="close()"> {{ t('cancelBtnText', 'cancelBtnText') }} </button>
      <button v-if="!loading && deleteItemModal.itemId" class="btn btn-danger" type="button" @click="deleteItem" > {{ t('deleteBtnText', 'deleteBtnText') }} </button>
      <b-button v-else variant="danger" disabled>
        {{t('deleteBtnText', 'deleteBtnText')}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
	name: 'ModalDeleteItem',
  data () {
    return {
      deleteItemModal: {},
      loading: false
    }
	},
	methods: {
    resetModal() {
      this.$emit('hide')
    },
    deleteItem() {
      this.loading = true
      this.$emit('deleteItem',  this.onComplete)
    },
    onComplete() {
      this.loading = false
    },
	},
  created() {
		this.deleteItemModal = this.$attrs.modal
  },		
}
</script>

<style scoped>

</style>